export default __webpack_public_path__ + "static/media/lactante_febril_sinfoco.e9179709.pdf";